import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useIntl } from 'react-intl';
import ProjectViewModal from './ProjectViewModal';
import {
    EventEmitter,
    getCurrentUserHook,
    getTranslatedText
} from '@nile/components/src';
import { AccountClient, SAVE_PERSONALIZATION } from '@nile/graphql/src';
import { ADD_VIEW } from '@nile/graphql/src/Mutation/views';
import { withRouter } from 'react-router-dom';

const CreateProjectView = (props) => {

    const { personalizedData, allViewsData, onClose } = props;

    const intl = useIntl();
    const user = getCurrentUserHook();

    const [mutateSidebarPersonalization] = useMutation(SAVE_PERSONALIZATION, {
        client: AccountClient
    });
    const [addProjectView] = useMutation(ADD_VIEW);

    // To Update the manageview pesrsonsalization api after adding the new projectview
    const saveSidebarCustomisation = useCallback(
        (value) => {
            return mutateSidebarPersonalization({
                variables: {
                    name: 'ManageViews',
                    category: 'workspace',
                    user: {
                        firstName: user?.firstName,
                        userId: user?.userId,
                        email: user?.email,
                        lastName: user?.lastName
                    },
                    value: JSON.stringify(value)
                }
            });
        },
        [user, mutateSidebarPersonalization]
    );

    // To add the new project view & update personaliztion 
    const addView = (input) => {
        return addProjectView({
            variables: { input }
        }).then(res => {
            const id = res?.data?.addView?.id;
            if (
                !personalizedData?.getPersonalizationByCategoryAndName
                    ?.value ||
                    personalizedData?.getPersonalizationByCategoryAndName
                      ?.value === 'null'
            ) {
                const dataToBeSaved = Object.entries(allViewsData)
                    .map(([key, value]) => {
                        return {
                            ...value,
                            section: key
                        };
                    }, [])
                    .reduce((acc, { section, heading, list, ...rest }) => {
                        const selectedViews = list.reduce(
                            (idList, { id, isChecked }) => {
                                if (isChecked) {
                                    idList.push(id);
                                }
                                return idList;
                            },
                            []
                        );
                        acc[section] = {
                            ...rest,
                            list:
                                // Add the new project view id in personlization
                                section === 'project'
                                    ? [id, ...selectedViews]
                                    : selectedViews
                        };
                        return acc;
                    }, {});
                return {id,dataToBeSaved};
            }
            const managePersonalizationViews = JSON.parse(
                personalizedData?.getPersonalizationByCategoryAndName?.value
            );

            managePersonalizationViews.project.list = [
                id,
                ...managePersonalizationViews.project.list
            ];
            return { id, managePersonalizationViews };
        }).then(({ id, managePersonalizationViews, dataToBeSaved }) => {
            if (managePersonalizationViews) {
                saveSidebarCustomisation(managePersonalizationViews);
            }
            else {
                saveSidebarCustomisation(dataToBeSaved);
            }
            return id;
        }).then((id) => {
            // To get new Project Views Api & manage view personalisation api
            EventEmitter.dispatch('newProjectViewAdded', id);
        })


    }

    const actions = {
        primaryAction: addView,
        back: onClose
    }

    return (
        <ProjectViewModal
            isOpen
            title={getTranslatedText(intl, 'project.view.create.header')}
            actions={actions}
        />
    )
}

export default withRouter(CreateProjectView);
